import Card from "components/card";
import { Image } from "components/Image";
import Nft2 from "assets/img/nfts/Nft2.png";
import { Integration } from "../types";
import { Loader2, Trash2 } from "lucide-react";
import { useTranslation } from "hooks/useTranslation";

const IntegrationCard = (props: {
  extra?: string;
  integration: Integration;
  onUpdate: (integration: Integration) => void;
  onDelete?: (integration: Integration) => void;
  isDeleting?: boolean;
}) => {
  const { integration, extra, onUpdate, onDelete, isDeleting } = props;
  const { t } = useTranslation();

  return (
    <Card
      extra={`flex flex-col w-full h-full !p-5 3xl:p-![18px] bg-white dark:bg-gray-900 ${
        extra || ""
      }`}
    >
      <div className="flex h-full w-full flex-col">
        <div className="relative mb-4 w-full">
          <Image
            src={""}
            fallbackSrc={Nft2}
            className="h-48 w-full rounded-xl bg-gray-100 object-cover dark:bg-gray-800"
            alt={integration.name}
          />
        </div>

        <div className="flex flex-1 flex-col">
          <div className="mb-4 flex items-start justify-between">
            <div className="flex-1">
              <h3 className="mb-1 text-lg font-bold text-navy-700 dark:text-white">
                {integration.name}
              </h3>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {t("integrations.lastUpdated")}{" "}
                {new Date(
                  integration.updated_at || integration.created_at
                ).toLocaleDateString()}
              </p>
            </div>
            <span
              className={`ml-3 whitespace-nowrap rounded-full bg-blue-500 px-3 py-1 text-xs font-medium text-white dark:text-gray-100`}
            >
              {integration.integration_type}
            </span>
          </div>

          <p className="mb-4 text-sm text-gray-700 dark:text-gray-300">
            {integration.description}
          </p>

          <div className="mt-auto flex flex-col gap-2 sm:flex-row sm:justify-between">
            <button
              onClick={() => onUpdate(integration)}
              className="rounded-lg px-4 py-2 text-center text-sm font-medium text-brand-900 transition duration-200 dark:text-brand-400"
            >
              {t("integrations.viewDetails")}
            </button>
            {onDelete && (
              <button
                onClick={() => onDelete(integration)}
                disabled={isDeleting}
                className="flex items-center gap-2 rounded-lg px-4 py-2 text-center text-sm font-medium text-red-600 transition duration-200 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50 dark:text-red-400 dark:hover:bg-red-900/20"
              >
                {isDeleting ? (
                  <Loader2 size={16} className="animate-spin" />
                ) : (
                  <Trash2 size={16} />
                )}
                {isDeleting ? t("common.deleting") : t("common.delete")}
              </button>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default IntegrationCard;
